export { default as MenuFooter } from './MenuFooter'
export { default as Newsletter } from './Newsletter'
export { default as SocialFooter } from './SocialFooter'
